<template>
  <section class="app-main">
    <transition name="fade-transform" mode="out-in">
      <keep-alive :include="cachedViews">
        <router-view :key="key" />
      </keep-alive>
    </transition>
    
    <ys-nameplate></ys-nameplate>
    
    <ys-footer></ys-footer>
  </section>
</template>

<script>
  import ysNameplate from '@/components/ys-nameplate'
  import ysFooter from '@/components/ys-footer'
  export default {
    name: 'AppMain',
    components: {
      ysNameplate,
      ysFooter
    },
    computed: {
      cachedViews() {
        return this.$store.state.tagsView.cachedViews
      },
      key() {
        return this.$route.path
      }
    }
  }
</script>

<style lang="scss" scoped>
  .app-main{
    position: relative;
    z-index: 1;
  }
  
  // fix css style bug in open el-dialog
  .el-popup-parent--hidden {
    .fixed-header {
      padding-right: 15px;
    }
  }

  .fade-transform-leave-active,
  .fade-transform-enter-active {
    transition: all .2s;
  }

  .fade-transform-enter {
    opacity: 0;
    transform: translateX(-30px);
  }

  .fade-transform-leave-to {
    opacity: 0;
    transform: translateX(30px);
  }
</style>
